<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hidefooter="true">
        <h3 slot="header" class="mb-0 font-weight-500">Update SMS Template</h3>

        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submit" ref="updateStatusForm">
                <b-row>
                    <!-- FIELD STATUS -->
                    <b-col cols="12">
                        <b-form-group label="Title:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'title'"
                            >
                            <b-form-input
                                v-model="form.sms_title"
                                type="text"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD STATUS TYPE -->
                    <b-col cols="12">
                        <b-form-group label="Content:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true, maxChars: true }"
                                :vid="'content'"
                            >
                            <b-form-textarea
                                v-model="form.sms_content"
                                placeholder="Enter sms content..."
                                rows="3"
                                max-rows="6"
                                ></b-form-textarea>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                <small v-if="!errors[0]" class="text-muted">{{ charCount }} characters | {{ smsCount }} SMS</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Customer Sub Status:">
                            <el-select
                                v-model="form.customer_status_id"
                                value-key="status_id"
                                filterable
                                >
                                <el-option :label="'-- Please select sub status --'" :value="null"></el-option>
                                <el-option
                                v-for="status in customerSubStatusList"
                                :key="status.status_id"
                                :label="status.parent_status + ' - ' + status.status"
                                :value="status.status_id"
                                >
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Update</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Select, Option, Checkbox } from 'element-ui'
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import mainEventBus from '@/assets/js/mainEventBus.js'
import { extend } from 'vee-validate';

export default {
    props: {
        update_sms_templates: Boolean,
        template_data: {
            type: Object
        },
        customerSubStatusList: Array,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
    },
    computed: {
        show: {
            get() {
                return this.update_sms_templates;
            },
            set(newVal) {
                this.$emit('update:update_sms_templates', newVal);
            },
        },
        charCount() {
            return this.form.sms_content.length;
        },
        smsCount() {
            return Math.ceil(this.charCount / 160);
        },
    },
    data() {
        return {
            form: {
                sms_title: '',
                sms_content: '',
                customer_status_id: null,
            },
        }
    },
    async created() {
        extend('maxChars', {
            validate: () => this.charCount <= 155,
            message: 'SMS Content should not exceed 155 characters',
        });
        this.$watch(
            () => this.template_data,
            (newVal) => {
                if (newVal) {
                    this.form.sms_template_id = newVal.sms_template_id ?? null;
                    this.form.sms_title = newVal.sms_title ?? '';
                    this.form.sms_content = newVal.sms_content ?? '';
                    this.form.customer_status_id = newVal.customer_status_id ?? null;
                }
            },
            { immediate: true }
        )
    },
    methods:{
        submit(){
            const formData = {
                sms_title: this.form.sms_title,
                sms_content: this.form.sms_content,
                customer_status_id: this.form.customer_status_id,
            }

            axios.put(services.messaging + 'sms-template/' + this.form.sms_template_id , formData, { headers: getHeader() })
            .then(res => {
                this.notifySuccess('<b>SMS Template</b> - Successfully Updated.')
                this.$emit('closeModal')
                mainEventBus.$emit('refresh-status')
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
    }
}
</script>